import { render, staticRenderFns } from "./InvestorReceivablePaymentsTable.vue?vue&type=template&id=179e855f&scoped=true&"
import script from "./InvestorReceivablePaymentsTable.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestorReceivablePaymentsTable.vue?vue&type=style&index=0&id=179e855f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179e855f",
  null
  
)

export default component.exports